<template>
    <modal-wrapper modalClass="modal" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h3>Vacature opstellen</h3>
        </div>
        <div class="modal__content">
            <div class="row">
                    <div class="col-md-12 col-lg-6">
                        <div class="form__group">
                            <label class="form__label">Branch</label>
                            <div class="select">
                                <select v-model="time.day">
                                    <option v-for="day in getDays()" :value="getDays().indexOf(day) + 1">{{day}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-6">
                        <div class="form__group">
                            <label class="form__label">Dag</label>
                            <div class="select">
                                <select v-model="time.day">
                                    <option v-for="day in getDays()" :value="getDays().indexOf(day) + 1">{{day}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__group">
                            <label class="form__label">Omschrijving</label>
                            <textarea class="form__input--textarea has-error" placeholder="Start typing here..."></textarea>
                            <span class="form__error_text">Error description</span>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form__group">
                            <label class="form__label">Contact e-mail:</label>
                            <input type="email" class="form__input--text" name="email"/>
                            <span class="form__error_text">Error description</span>
                        </div>
                    </div>
            </div>
        </div>
        <div class="modal__footer">
            <button class="button--cta" type="submit" @click="save">Opslaan</button>
            <button class="button--alt" type="button" @click="$modal.hide(name)">Annuleer</button>
        </div>

        <div class="loading" v-if="loading">
            <div class="spinner" style="top: 40%;"></div>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import ModalWrapper from '@/components/general/ModalWrapper';

    import {getDayLong, getDaysLong} from '@/utils';
    import { Validator } from 'vee-validate';
    @Component
    export default class AddRecruitmentModal extends Vue {
        name = 'add-recruitment-modal';

        time = {};

        loading = false;

        created() {

        }

        save() {
            this.loading = true;
//            this.$emit('save', this.time);
            this.validate();
        }

        getDay(day) {
            return getDayLong(day);
        }

        getDays() {
            return getDaysLong();
        }

        beforeOpen(event) {
            var time = event.params.time;
            this.loading = false;
            this.time = (!time || time === undefined) ? {} : time;
        }

        validate() {

        }
    }

    Vue.component(AddRecruitmentModal.name, AddRecruitmentModal);
</script>



// WEBPACK FOOTER //
// src/pages/market/modals/AddRecruitmentModal.vue